import React from 'react';
import styled from 'styled-components';
import { IFilterItem } from './FilterItemCmp';
import ArrowForwardIcon from '@material-ui/icons/ArrowForward';
import Image from 'next/image';
import { ColorMarker } from '@/components/atoms';

interface StyleProps {
  role?: string;
  active?: boolean;
}

const Wrapper = styled.div<StyleProps>`
  background: ${props =>
    props.active ? props.theme.filterPanel.backgroundColor : 'transparent'};
`;

const Content = styled.div`
  height: 100%;
  display: flex;
  align-items: center;
`;
const Label = styled.div``;

const LabelContent = styled.div`
  display: flex;
  align-items: center;
  width: 90%;
  padding: 8px;
  cursor: pointer;
`;
const SubLabel = styled.div`
  margin-top: 4px;
  font-size: smaller;
`;

const LabelsWrapper = styled.div`
  display: flex;
  flex-direction: column;
`;

const CloseIconWrapper = styled.div`
  color: ${props => props.theme.paletteDefault.grey1};
  display: flex;
  align-items: center;
  cursor: pointer;
`;
const ArrowIconWrapper = styled.div`
  display: flex;
  align-items: center;
  cursor: pointer;
`;
const FilterItem: React.FC<IFilterItem> = ({
  label,
  subLabel,
  role = 'child',
  active = false,
  clickHandler,
  removeHandler,
  hasChildren,
  colorInfo,
}) => {
  return (
    <Wrapper role={role} active={active}>
      <Content>
        <LabelContent onClick={clickHandler}>
          {colorInfo && (
            <ColorMarker
              key={`color-${label}`}
              bgcolor={colorInfo.bgColor}
              bgimageUrl={colorInfo?.bgImageUrl}
              label={label || ''}
              showLabel={false}
              size="small"></ColorMarker>
          )}
          <LabelsWrapper>
            <Label>{label}</Label>
            {subLabel && <SubLabel>{subLabel}</SubLabel>}
          </LabelsWrapper>
        </LabelContent>
        {active && removeHandler && (
          <CloseIconWrapper onClick={removeHandler}>
            <Image
              src="/asset/closeIcon.svg"
              alt={'close icon'}
              width={18}
              height={18}
              unoptimized={true}
            />
          </CloseIconWrapper>
        )}
        {!active && hasChildren && (
          <ArrowIconWrapper onClick={clickHandler}>
            <ArrowForwardIcon
              style={{
                color: '#787878',
                width: '18px',
                height: '18px',
              }}
            />
          </ArrowIconWrapper>
        )}
      </Content>
    </Wrapper>
  );
};

export default FilterItem;
